module.exports = __webpack_public_path__ + "img/commerce-1.8b5e66ad.png";